module.exports = __webpack_public_path__ + "img/no-select.fc981d86.png";